import PropTypes from "prop-types";
import React from "react";
import Button from "@mui/material/Button";
import MDialog from "components/Shared/MDialog.tsx";

export const MODES = {
  DELETE: "DELETE",
  CLOSE: "CLOSE"
};

const getDialogButtons = (onCancel, onConfirm, confirmLabel) => {
  let buttons = [];
  buttons.push(<Button key="confirm" onClick={onConfirm} >{confirmLabel}</Button>);
  buttons.push(<Button key="cancel" variant="text" color="secondary" onClick={onCancel}>Cancel</Button>);
  return buttons;
};

const CloseDeleteIncidentDialog = props => {
  const modeAction = props.mode === MODES.DELETE ? "Delete" : "Resolve";
  return (
    <MDialog
      id="cs-close-delete-incident"
      className="cs-close-delete-incident-dialog"
      title={`${modeAction} Note`}
      visible={props.dialogVisible}
      contentActions={getDialogButtons(props.hideDialog, props.onConfirm, modeAction)}
      focusOnMount={false}
      width={400}
    >
      <p>{`Are you sure you want to ${modeAction.toLowerCase()} this note?`}</p>
      {props.mode == MODES.DELETE && <p>This cannot be undone.</p>}
    </MDialog>
  );
};

CloseDeleteIncidentDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired,       // Function to call when user clicks confirm
  mode: PropTypes.string.isRequired,          // "DELETE" or "CLOSE" see const in CloseDeleteIncident
  dialogVisible: PropTypes.bool.isRequired,   // Show or hide the dialog
  hideDialog: PropTypes.func.isRequired,      // Function to call on cancel or clicking outside of the dialog
};

export default CloseDeleteIncidentDialog;